module.exports = __webpack_public_path__ + "static/media/vantage-circle-logo.8d4fa829.png";